import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Non- resident Alien</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Tax Filing Made Simple for Non-Resident Aliens</h3>
                        <p>
                            Navigating the U.S. tax system as a non-resident
                            alien can be complex and overwhelming. At{" "}
                            <b>Serene Tax</b>, we specialize in providing
                            tailored tax filing solutions for non-residents,
                            ensuring compliance with U.S. tax laws while
                            minimizing your tax liabilities.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>Who is Considered a Non-Resident Alien?</h3>
                        <p>
                            A <b>non-resident alien</b> is an individual who is
                            not a U.S. citizen and does not meet the substantial
                            presence test or the green card test. This category
                            typically includes:
                        </p>
                        <ul>
                            <li>International students (F-1, J-1 visas)</li>
                            <li>Scholars or researchers</li>
                            <li>
                                Non-residents with U.S. income or investments
                            </li>
                        </ul>
                        <p>
                            <b>
                                Why Non-Resident Aliens Need Tax Filing Services
                            </b>
                            <br />
                            As a non-resident alien, you are required to file
                            taxes if you:
                        </p>
                        <ul>
                            <li>
                                Earn income from U.S. sources (wages, investment
                                income, etc.).
                            </li>
                            <li>Have a U.S. business or trade.</li>
                            <li>Wish to claim tax treaty benefits.</li>
                        </ul>
                        <p>
                            Filing incorrectly or failing to file can lead to
                            penalties, loss of tax treaty benefits, or
                            complications with visa renewals
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Why Choose Serene Tax for Non-Resident Alien Tax
                            Filing?
                        </h3>
                        <p>
                            <b>Expertise in International Taxation:</b>
                            We understand the unique tax filing requirements for
                            non-residents.
                        </p>
                        <p>
                            <b>Tailored Solutions:</b>
                            Services customized to your specific visa status and
                            financial situation.
                        </p>
                        <p>
                            <b>Compliance Guaranteed:</b>Stay compliant with IRS
                            regulations and tax treaties.
                        </p>
                        <p>
                            <b>Simplified Process:</b> We handle the
                            complexities so you can focus on your studies, work,
                            or other priorities.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>
                            Our Non-Resident Alien Tax Filing Services Include
                        </h3>
                        <p>
                            <b>1.Form 1040-NR Preparation</b>
                            <br />
                            We prepare and file Form 1040-NR, ensuring accurate
                            reporting of your income and deductions.
                        </p>
                        <p>
                            <b>2.Tax Treaty Benefits</b>
                            <br />
                            We identify applicable tax treaties between your
                            home country and the U.S. to reduce your tax burden.
                        </p>
                        <p>
                            <b>3..ITIN Assistance</b>
                            <br />
                            If you need an Individual Taxpayer Identification
                            Number (ITIN), we’ll help you obtain one quickly and
                            efficiently.
                        </p>
                        <p>
                            <b>4.State Tax Returns</b>
                            <br />
                            We prepare and file state tax returns for
                            non-residents with income in specific states.
                        </p>
                        <p>
                            <b>5.Amendments and Late Filings</b>
                            <br />
                            Missed a filing? We help with corrections or
                            submissions under IRS guidelines to avoid penalties.
                            1
                        </p>
                    </div>
                </div>

                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>File with Confidence Today!</h3>
                        <p>
                            Don’t let the complexities of U.S. tax laws
                            overwhelm you. With <b>Serene Tax</b>, nonresident
                            alien tax filing is simple, accurate, and
                            stress-free.
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
